// ToDo: vereinen? general: { ... } --> main: general + {}
export const MAP_OPTIONS = {
    main: {
        gestureHandling: 'greedy',
        zoomControl: false,
        mapTypeControl: true,
        streetViewControl: false,
        panControl: true,
        rotateControl: true,
        fullscreenControl: false
    },
    gallery: {
        gestureHandling: 'greedy',
        zoomControl: false,
        mapTypeControl: true,
        streetViewControl: false,
        panControl: true,
        rotateControl: true,
        fullscreenControl: false
    }
    // Weitere Modi hinzufügen
}